var map = {
	"./apple.png": 81119,
	"./baby.png": 98665,
	"./ball.png": 45930,
	"./banana.png": 95074,
	"./bed.png": 48798,
	"./bicycle.png": 65364,
	"./boat.png": 49700,
	"./book.png": 64004,
	"./boot.png": 2243,
	"./cat.png": 30090,
	"./chair.png": 75254,
	"./check.png": 18840,
	"./cow.png": 85019,
	"./crocodile.png": 15593,
	"./cross.png": 84377,
	"./cup.png": 85791,
	"./doll.png": 71688,
	"./dysmate-logo-hvit-small.png": 64222,
	"./ear.png": 11446,
	"./elephant.png": 27407,
	"./eye.png": 86339,
	"./finger.png": 27879,
	"./fireengine.png": 69837,
	"./fish.png": 32405,
	"./flower.png": 73758,
	"./flowers.png": 52940,
	"./foot.png": 83041,
	"./gloves.png": 52388,
	"./horse.png": 73023,
	"./house.png": 45202,
	"./icecream.png": 51353,
	"./jeans.png": 57109,
	"./key.png": 67986,
	"./laptop-icon.png": 62295,
	"./lion.png": 98986,
	"./literate-regular-light.png": 81506,
	"./logo-white-2.png": 45768,
	"./motorcycle.png": 12180,
	"./nose.png": 16889,
	"./package.png": 98558,
	"./pc-icon.png": 70792,
	"./plane.png": 38975,
	"./plowtruck.png": 17391,
	"./porrige.png": 75300,
	"./purse.png": 24996,
	"./rabbit.png": 11538,
	"./rapidNaming/bamse.png": 82150,
	"./rapidNaming/blabamse.png": 32769,
	"./rapidNaming/blaeple.png": 6822,
	"./rapidNaming/blagenser.png": 44555,
	"./rapidNaming/blasykkel.png": 80626,
	"./rapidNaming/blatommel.png": 52903,
	"./rapidNaming/de/dog-blue.png": 99278,
	"./rapidNaming/de/dog-brown.png": 41852,
	"./rapidNaming/de/dog-green.png": 70937,
	"./rapidNaming/de/dog-grey.png": 29158,
	"./rapidNaming/de/dog-red.png": 92486,
	"./rapidNaming/de/dog-yellow.png": 33101,
	"./rapidNaming/de/door-blue.png": 23808,
	"./rapidNaming/de/door-brown.png": 53949,
	"./rapidNaming/de/door-green.png": 82525,
	"./rapidNaming/de/door-grey.png": 72835,
	"./rapidNaming/de/door-red.png": 55374,
	"./rapidNaming/de/door-yellow.png": 34454,
	"./rapidNaming/de/moon-blue.png": 38510,
	"./rapidNaming/de/moon-brown.png": 26299,
	"./rapidNaming/de/moon-green.png": 31265,
	"./rapidNaming/de/moon-grey.png": 52778,
	"./rapidNaming/de/moon-red.png": 57655,
	"./rapidNaming/de/moon-yellow.png": 20226,
	"./rapidNaming/de/shoe-blue.png": 98928,
	"./rapidNaming/de/shoe-brown.png": 93833,
	"./rapidNaming/de/shoe-green.png": 97335,
	"./rapidNaming/de/shoe-grey.png": 88704,
	"./rapidNaming/de/shoe-red.png": 9427,
	"./rapidNaming/de/shoe-yellow.png": 41790,
	"./rapidNaming/de/tree-blue.png": 61693,
	"./rapidNaming/de/tree-brown.png": 61159,
	"./rapidNaming/de/tree-green.png": 79082,
	"./rapidNaming/de/tree-grey.png": 10238,
	"./rapidNaming/de/tree-red.png": 98286,
	"./rapidNaming/de/tree-yellow.png": 88199,
	"./rapidNaming/elefant.png": 75745,
	"./rapidNaming/eple.png": 31510,
	"./rapidNaming/genser.png": 26023,
	"./rapidNaming/grabamse.png": 95929,
	"./rapidNaming/graeple.png": 1869,
	"./rapidNaming/gragenser.png": 87552,
	"./rapidNaming/grasykkel.png": 55636,
	"./rapidNaming/gratommel.png": 86818,
	"./rapidNaming/gronnbamse.png": 68760,
	"./rapidNaming/gronneple.png": 74529,
	"./rapidNaming/gronngenser.png": 70936,
	"./rapidNaming/gronnsykkel.png": 47051,
	"./rapidNaming/gronntommel.png": 68559,
	"./rapidNaming/oransjebamse.png": 17676,
	"./rapidNaming/oransjeeple.png": 60032,
	"./rapidNaming/oransjegenser.png": 32923,
	"./rapidNaming/oransjesykkel.png": 26353,
	"./rapidNaming/oransjetommel.png": 99283,
	"./rapidNaming/paraply.png": 20440,
	"./rapidNaming/prinsesse.png": 79646,
	"./rapidNaming/rodbamse.png": 86929,
	"./rapidNaming/rodeple.png": 91597,
	"./rapidNaming/rodgenser.png": 58067,
	"./rapidNaming/rodsykkel.png": 54615,
	"./rapidNaming/rodtommel.png": 37916,
	"./rapidNaming/se/apple-blue.png": 68415,
	"./rapidNaming/se/apple-green.png": 75221,
	"./rapidNaming/se/apple-grey.png": 66356,
	"./rapidNaming/se/apple-orange.png": 73376,
	"./rapidNaming/se/apple-red.png": 256,
	"./rapidNaming/se/bike-blue.png": 98536,
	"./rapidNaming/se/bike-green.png": 55449,
	"./rapidNaming/se/bike-grey.png": 56401,
	"./rapidNaming/se/bike-orange.png": 34363,
	"./rapidNaming/se/bike-red.png": 95810,
	"./rapidNaming/se/flower-blue.png": 52322,
	"./rapidNaming/se/flower-green.png": 67439,
	"./rapidNaming/se/flower-grey.png": 73493,
	"./rapidNaming/se/flower-orange.png": 37162,
	"./rapidNaming/se/flower-red.png": 81719,
	"./rapidNaming/se/table-blue.png": 32281,
	"./rapidNaming/se/table-green.png": 56689,
	"./rapidNaming/se/table-grey.png": 33363,
	"./rapidNaming/se/table-orange.png": 25394,
	"./rapidNaming/se/table-red.png": 43709,
	"./rapidNaming/se/woman-blue.png": 93910,
	"./rapidNaming/se/woman-green.png": 90857,
	"./rapidNaming/se/woman-grey.png": 59027,
	"./rapidNaming/se/woman-orange.png": 20410,
	"./rapidNaming/se/woman-red.png": 52394,
	"./rapidNaming/se/zebra-blue.png": 33442,
	"./rapidNaming/se/zebra-green.png": 56878,
	"./rapidNaming/se/zebra-grey.png": 53011,
	"./rapidNaming/se/zebra-orange.png": 48815,
	"./rapidNaming/se/zebra-red.png": 50519,
	"./rapidNaming/stoevsuger.png": 75067,
	"./rapidNaming/sykkel.png": 82670,
	"./rapidNaming/tannboerste.png": 79073,
	"./rapidNaming/tommel.png": 91193,
	"./reflex.png": 69256,
	"./saft.png": 38504,
	"./server-icon.png": 26264,
	"./shoe.png": 61837,
	"./ski.png": 6994,
	"./spoon.png": 77050,
	"./sun.png": 21932,
	"./sweater.png": 26643,
	"./teddy.png": 41334,
	"./telephone.png": 72185,
	"./tractor.png": 69941
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;